import { ExportFile } from '../types/export/export';
import {
  ReorderRuleExportConfiguration,
  CreateReorderRuleExportConfigurationInput,
  UpdateReorderRuleExportConfigurationInput,
  DeleteReorderRuleExportConfigurationInput,
} from '../types/reorder_rule_export_configuration';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const EXPORT = '/api/reorder_rule/export';
const CONFIGURATIONS = '/api/reorder_rule/export/list';
const CREATE_CONFIGURATION = '/api/reorder_rule/export/create';
const UPDATE_CONFIGURATION = '/api/reorder_rule/export/update';
const DELETE_CONFIGURATION = '/api/reorder_rule/export/delete';

export namespace ReorderRuleExportConfigurationRequest {
  export interface ReorderRuleExportPayload {
    configId?: string;
    timezone?: string;
    locale?: string;
    page?: number;
    groupIds?: string[];
  }

  export const download = async (payload: ReorderRuleExportPayload): Promise<ExportFile> => {
    return (await http.post(EXPORT, payload)).data;
  };

  export const list = async (payload: { page: number }): Promise<PaginatedResponse<ReorderRuleExportConfiguration>> => {
    return (await http.post(CONFIGURATIONS, payload)).data;
  };

  export const create = async (payload: {
    data: CreateReorderRuleExportConfigurationInput[];
  }): Promise<ReorderRuleExportConfiguration[]> => {
    return (await http.post(CREATE_CONFIGURATION, payload)).data;
  };

  export const update = async (payload: {
    data: UpdateReorderRuleExportConfigurationInput[];
  }): Promise<ReorderRuleExportConfiguration[]> => {
    return (await http.post(UPDATE_CONFIGURATION, payload)).data;
  };

  export const remove = async (payload: {
    data: DeleteReorderRuleExportConfigurationInput[];
  }): Promise<ReorderRuleExportConfiguration[]> => {
    return (await http.post(DELETE_CONFIGURATION, payload)).data;
  };
}
